import { OktonSearchFilter } from '@okton/platform-ui';
import React, { useState } from 'react';
import { Box, Heading, Text, Flex, useColorModeValue } from '@chakra-ui/react';
import { BookOpenText } from 'lucide-react';
import Page from '../../layout/IntegraAppPage';

const Ajuda = () => {
  const corDeFundo = useColorModeValue('white', 'gray.800');
  const corDaBorda = useColorModeValue('gray.200', 'gray.700');
  const corTextoPrincipal = useColorModeValue('gray.800', 'whiteAlpha.900');
  const corTextoSecundario = useColorModeValue('gray.500', 'gray.400');

  const corDicaBg = useColorModeValue('blue.50', 'rgba(66, 153, 225, 0.1)');
  const corDicaText = useColorModeValue('blue.600', 'blue.200');
  const corIconeDestaque = useColorModeValue('#3182ce', '#63b3ed');

  const [busca, setBusca] = useState('');

  return (
    <Page>
      {/* header */}
      <Flex mb={6} align="flex-end">
        <Box>
          <Flex align="center" gap={2} mb={1}>
            <BookOpenText size={24} color={corIconeDestaque} />
            <Heading size="lg" color={corTextoPrincipal}>
              ⠀Central de Ajuda
            </Heading>
          </Flex>

          <Text fontSize="sm" color={corTextoSecundario}>
            Documentação completa de todos os módulos do sistema
          </Text>
        </Box>
      </Flex>

      {/*  */}
      <Flex gap={6} align="stretch" direction={{ base: 'column', lg: 'row' }}>
        {/* esquerda */}
        <Box w="320px">
          <OktonSearchFilter
            value={busca}
            onChange={setBusca}
            placeholder="Buscar módulo..."
            minWidth={280}
            maxWidth={320}
          />

          <Text fontSize="sm" fontWeight="600" color={corTextoPrincipal}>
            Módulos do Sistema
          </Text>

          {/* */}
          <Text mt={4} fontSize="xs" color={corTextoSecundario}>
            Aguardando integração de dados...
          </Text>
        </Box>

        {/* box direita */}
        <Box
          flex="1"
          bg={corDeFundo}
          border="1px solid"
          borderColor={corDaBorda}
          borderRadius="2xl"
          minH="400px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={6}
          shadow="sm"
        >
          <Flex direction="column" align="center" gap={3}>
            <BookOpenText
              size={48}
              color={useColorModeValue('gray.300', 'gray.600')}
            />

            <Text fontWeight="600" fontSize="xl" color={corTextoPrincipal}>
              Bem-vindo à Central de Ajuda
            </Text>

            <Text
              fontSize="sm"
              color={corTextoSecundario}
              textAlign="center"
              maxW="400px"
              lineHeight="tall"
            >
              Selecione um módulo na lista ao lado para visualizar a
              documentação completa com exemplos práticos de uso.
            </Text>

            {/* texto dica */}
            <Box
              mt={4}
              px={6}
              py={3}
              borderRadius="xl"
              bg={corDicaBg}
              color={corDicaText}
              fontSize="sm"
              textAlign="center"
              border="1px solid"
              borderColor={useColorModeValue('blue.100', 'blue.800')}
            >
              <Text fontWeight="500">
                Dica: Use a busca para encontrar rapidamente o módulo que você
                precisa.
              </Text>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Page>
  );
};

export default Ajuda;
